import React from 'react'
import { useLocation } from 'react-router-dom'

const withPathname = WrappedComponent => {
  return props => {
    const location = useLocation()
    const pathname = location.pathname

    return <WrappedComponent pathname={pathname} {...props} />
  }
}

export default withPathname
